module.exports = __webpack_public_path__ + "static/media/neuter.b5fffd10.svg";